"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPolkaBTCAPI = exports.getBitcoinNetwork = void 0;
const electrs_1 = require("./external/electrs");
const issue_1 = require("./parachain/issue");
const oracle_1 = require("./parachain/oracle");
const redeem_1 = require("./parachain/redeem");
const refund_1 = require("./parachain/refund");
const fee_1 = require("./parachain/fee");
const staked_relayer_1 = require("./parachain/staked-relayer");
const vaults_1 = require("./parachain/vaults");
const system_1 = require("./parachain/system");
const collateral_1 = require("./parachain/collateral");
const treasury_1 = require("./parachain/treasury");
const clients_1 = require("./clients");
const btc_relay_1 = require("./parachain/btc-relay");
const replace_1 = require("./parachain/replace");
const bitcoinjs_lib_1 = require("bitcoinjs-lib");
__exportStar(require("./factory"), exports);
__exportStar(require("./parachain/transaction"), exports);
function getBitcoinNetwork(network = "mainnet") {
    switch (network) {
        case "mainnet":
            return bitcoinjs_lib_1.networks.bitcoin;
        case "testnet":
            return bitcoinjs_lib_1.networks.testnet;
        default:
            return bitcoinjs_lib_1.networks.regtest;
    }
}
exports.getBitcoinNetwork = getBitcoinNetwork;
/**
 * @category PolkaBTC Bridge
 * The type Big represents DOT or PolkaBTC denominations,
 * while the type BN represents Planck or Satoshi denominations.
 */
class DefaultPolkaBTCAPI {
    constructor(api, network = "mainnet", _account) {
        this.api = api;
        this._account = _account;
        const btcNetwork = getBitcoinNetwork(network);
        this.vaults = new vaults_1.DefaultVaultsAPI(api, btcNetwork, _account);
        this.faucet = new clients_1.FaucetClient("");
        this.oracle = new oracle_1.DefaultOracleAPI(api);
        this.electrsAPI = new electrs_1.DefaultElectrsAPI(network);
        this.stakedRelayer = new staked_relayer_1.DefaultStakedRelayerAPI(api, btcNetwork, this.electrsAPI, _account);
        this.refund = new refund_1.DefaultRefundAPI(api, btcNetwork, this.electrsAPI, _account);
        this.btcRelay = new btc_relay_1.DefaultBTCRelayAPI(api, this.electrsAPI);
        this.collateral = new collateral_1.DefaultCollateralAPI(api, _account);
        this.treasury = new treasury_1.DefaultTreasuryAPI(api, _account);
        this.system = new system_1.DefaultSystemAPI(api);
        this.replace = new replace_1.DefaultReplaceAPI(api, btcNetwork, this.electrsAPI, _account);
        this.fee = new fee_1.DefaultFeeAPI(api);
        this.issue = new issue_1.DefaultIssueAPI(api, btcNetwork, this.electrsAPI, _account);
        this.redeem = new redeem_1.DefaultRedeemAPI(api, btcNetwork, this.electrsAPI, _account);
    }
    setAccount(account, signer) {
        if (!account.sign && !signer) {
            throw new Error("signer must be passed if account is not a Keypair");
        }
        if (signer) {
            this.api.setSigner(signer);
        }
        this._account = account;
        this.vaults.setAccount(account);
        this.stakedRelayer.setAccount(account);
        this.refund.setAccount(account);
        this.collateral.setAccount(account);
        this.treasury.setAccount(account);
        this.replace.setAccount(account);
        this.issue.setAccount(account);
        this.redeem.setAccount(account);
    }
    get account() {
        return this._account;
    }
}
exports.DefaultPolkaBTCAPI = DefaultPolkaBTCAPI;
//# sourceMappingURL=polkabtc-api.js.map